<div
  class="eva-datepicker"
  [class.eva-datepicker--open]="isOpen"
  [class.eva-datepicker--error]="error"
  [class.eva-datepicker--disabled]="disabled"
  [class.eva-datepicker--focused]="isFocused"
  [class.eva-datepicker--has-value]="hasValue"
  [class.eva-datepicker--small]="size === 'small'"
  [class.eva-datepicker--medium]="size === 'medium'"
  [class.eva-datepicker--large]="size === 'large'"
>
  <!-- Label -->
  <label *ngIf="label" [for]="inputId" class="eva-datepicker__label">
    {{ label }}<span *ngIf="required" class="eva-datepicker__required">*</span>
  </label>

  <!-- Trigger -->
  <div
    *ngIf="!inline"
    #triggerRef
    class="eva-datepicker__trigger"
    role="combobox"
    [attr.aria-expanded]="isOpen"
    [attr.aria-disabled]="disabled"
    (click)="onTriggerClick($event)"
  >
    <!-- Icon calendrier -->
    <ng-icon name="heroCalendar" class="eva-datepicker__icon"></ng-icon>

    <!-- Input éditable (single mode) / readonly (range mode) -->
    <input
      type="text"
      class="eva-datepicker__input"
      [attr.id]="inputId"
      [value]="range ? displayValue : inputText"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="range"
      autocomplete="off"
      (input)="onInputChange($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      (keydown)="handleInputKeydown($event)"
    />

    <!-- Right icons -->
    <span class="eva-datepicker__icons">
      <!-- Clear button -->
      <button *ngIf="showClear" type="button" class="eva-datepicker__clear" tabindex="-1" (click)="clear($event)">
        <ng-icon name="heroXMark"></ng-icon>
      </button>

      <!-- Dropdown arrow -->
      <ng-icon name="heroChevronDown" class="eva-datepicker__arrow"></ng-icon>
    </span>
  </div>

  <!-- Calendar dropdown -->
  <div
    *ngIf="isOpen || inline"
    #calendarRef
    class="eva-datepicker__calendar"
    [class.eva-datepicker__calendar--with-presets]="showPresets"
    [class.eva-datepicker__calendar--inline]="inline"
  >
    <!-- Presets panel (left side) -->
    <div *ngIf="showPresets" class="eva-datepicker__presets">
      <div class="eva-datepicker__presets-title">Selections rapides</div>
      <div class="eva-datepicker__presets-list">
        @for (preset of activePresets; track preset.label) {
          <button
            type="button"
            class="eva-datepicker__preset-btn"
            [class.eva-datepicker__preset-btn--active]="isPresetActive(preset)"
            (click)="selectPreset(preset); $event.stopPropagation()"
          >
            @if (isNgIconName(preset.icon)) {
              <ng-icon [name]="preset.icon"></ng-icon>
            } @else if (preset.icon) {
              <i [class]="preset.icon"></i>
            }
            {{ preset.label }}
          </button>
        }
      </div>
    </div>

    <!-- Calendar panel (right side when presets, full width otherwise) -->
    <div class="eva-datepicker__calendar-panel">
      <!-- Header -->
      <div class="eva-datepicker__header">
        <button type="button" class="eva-datepicker__nav-btn" (click)="previousMonth(); $event.stopPropagation()">
          <ng-icon name="heroChevronLeft"></ng-icon>
        </button>

        <span class="eva-datepicker__month-label">{{ currentMonthLabel }}</span>

        <button type="button" class="eva-datepicker__nav-btn" (click)="nextMonth(); $event.stopPropagation()">
          <ng-icon name="heroChevronRight"></ng-icon>
        </button>
      </div>

      <!-- Week days header -->
      <div class="eva-datepicker__weekdays" [class.eva-datepicker__weekdays--with-week]="showWeek">
        <span *ngIf="showWeek" class="eva-datepicker__weeknum eva-datepicker__weeknum--head">S</span>
        <span *ngFor="let day of weekDays" class="eva-datepicker__weekday">{{ day }}</span>
      </div>

      <!-- Days grid -->
      <div class="eva-datepicker__days">
        <div
          *ngFor="let week of calendarDays; trackBy: trackByWeek"
          class="eva-datepicker__week"
          [class.eva-datepicker__week--with-week]="showWeek"
        >
          <span *ngIf="showWeek" class="eva-datepicker__weeknum">{{ getWeekNumber(week) }}</span>
          <div *ngFor="let day of week; trackBy: trackByDay" class="eva-datepicker__day-cell">
            <button
              *ngIf="day"
              type="button"
              class="eva-datepicker__day"
              [class.eva-datepicker__day--today]="isToday(day)"
              [class.eva-datepicker__day--selected]="isDateSelected(day)"
              [class.eva-datepicker__day--in-range]="isDateInRange(day)"
              [class.eva-datepicker__day--disabled]="isDateDisabled(day)"
              [disabled]="isDateDisabled(day)"
              (click)="selectDate(day); $event.stopPropagation()"
              (mouseenter)="onDayHover(day)"
              (mouseleave)="onDayHover(null)"
            >
              {{ day.getDate() }}
            </button>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="eva-datepicker__footer">
        <button type="button" class="eva-datepicker__today-btn" (click)="goToToday(); $event.stopPropagation()">
          Aujourd'hui
        </button>
      </div>
    </div>
  </div>

  <!-- Helper text -->
  <small *ngIf="helper && !error" class="eva-datepicker__helper">
    {{ helper }}
  </small>

  <!-- Error message -->
  <small *ngIf="error" class="eva-datepicker__error-text">
    {{ error }}
  </small>
</div>
